import script from "./CryptoPlanCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CryptoPlanCard.vue?vue&type=script&setup=true&lang=ts"

import "./CryptoPlanCard.vue?vue&type=style&index=0&id=16e28c86&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16e28c86"]])

export default __exports__